module.exports = __webpack_public_path__ + "img/ffBanner_MO.bc42d181.png";